import { Injectable } from '@angular/core';
import { map } from 'rxjs/operators';
import { Observable } from 'rxjs';

import { ExtendedHttpResponse, HttpInterceptorService } from '@ispm/core/services/http-interceptor.service';

@Injectable()
export class ReportPreviewService {
  baseUrl = '/report';
  baseTestUrl = '/test';
  baseValueSetUrl = '/valueset';

  constructor(
    private http: HttpInterceptorService
  ) { }

  public renderHTMLReport(xHtmlReportTemplate, analysis, testParams, testNumber, revisionDetails): Observable<ExtendedHttpResponse<any>> {
    return this.http.post(
      `${this.baseUrl}/render`,
      {
        xHtmlReportTemplate: xHtmlReportTemplate,
        analysis: analysis,
        testNumber: testNumber,
        firstRevisionId: revisionDetails.firstRevisionId,
        revisionId: revisionDetails.revisionId,
        revisionName: revisionDetails.revisionName,
        revisionStatus: revisionDetails.revisionStatus,
        workflowId: testParams.testId
      }
    )
      .pipe(
      map(res => res.json()),
      map(res => res?.content)
    );
  }

  public getRelatedControlTests(revisionId, testType): Observable<ExtendedHttpResponse<any>> {
    return this.http.get(`${this.baseTestUrl}/getRelatedControlTests`, { workflowId: revisionId, testType: testType })
      .pipe(
        map(res => res ? res.body : res)
      );
  }

  public getControlSampleStatuses(): Observable<ExtendedHttpResponse<any>> {
    return this.http.get(`${this.baseValueSetUrl}/getNavicanControlTestStatuses`, { })
      .pipe(
        map(returnedValueSet => returnedValueSet.body)
      );
  }

  public releaseFinalReport(userId, xHtmlReportTemplate, analysis, revisionDetails, testNumber, testParams, interpretationText): Observable<ExtendedHttpResponse<any>> {
    const request = {
      userId: userId,
      xHtmlReportTemplate: xHtmlReportTemplate,
      analysis: analysis,
      testNumber: testNumber,
      firstRevisionId: revisionDetails.firstRevisionId,
      revisionId: revisionDetails.revisionId,
      revisionName: revisionDetails.revisionName,
      revisionStatus: revisionDetails.revisionStatus,
      workflowId: testParams.testId,
    };

    if (interpretationText != null && interpretationText !== '') {
      request['interpretationText'] = interpretationText;
    }

    return this.http.post(`${this.baseUrl}/release`, request);
  }

  public releaseAddendumReport(userId, xHtmlReportTemplate, analysis, revisionDetails, testNumber, testParams, addendum: any = null): Observable<ExtendedHttpResponse<any>> {
    const request = {
      userId: userId,
      xHtmlReportTemplate: xHtmlReportTemplate,
      analysis: analysis,
      testNumber: testNumber,
      firstRevisionId: revisionDetails.firstRevisionId,
      revisionId: revisionDetails.revisionId,
      revisionName: revisionDetails.revisionName,
      revisionStatus: revisionDetails.revisionStatus,
      workflowId: testParams.testId
    };

    if (addendum != null) {
      request['updateText'] = addendum.updateText;
      request['clientDate'] = addendum.clientDate;
      request['userId'] = addendum.userId;
      request['reportTemplatesExist'] = addendum.reportTemplatesExist;
    }

    return this.http.post(`${this.baseUrl}/addendum`, request);
  }

  public postReportToEmr(workflowId: string, revisionId: string): Observable<boolean> {
    return this.http.post(
      `${this.baseUrl}/sendToEmr`,
      {
        workflowId: workflowId,
        revisionId: revisionId,
      },
      false,
      {
        'Content-Type': 'application/json'
      }
    )
      .pipe(
        map(res => !!(res && res.body))
      );
  }
}

